import {
  BOOLEAN_SELECT_LIST_ITEMS,
  Card,
  Checkbox,
  CrudMode,
  DataDisplay,
  formatBoolean,
  Grid,
  pn,
  Typography,
  useElementBreakpoints,
  ValidationErrors,
} from "@compass/core";
import { Input, Select } from "components";
import { LkRole, LkStudentDisplayFieldId, User, UserEditResource, UserViewResource } from "generated/openApi";
import produce from "immer";
import "moment-timezone";

export const Notification = (props: {
  crudMode: CrudMode;
  user: User;
  setUser: (value: User) => void;
  viewResource: UserViewResource;
  editResource: UserEditResource;
  validationErrors: ValidationErrors;
  selectedRole: LkRole | undefined;
}) => {
  const { breakpointsRef, smallFieldBreakpoints } = useElementBreakpoints();
  const properties = props.viewResource.properties || [];

  const studentUnresponsiveField = props.viewResource.studentDisplayFields?.find(
    (x) => x.id === LkStudentDisplayFieldId.Unresponsive
  );

  const showNotification = studentUnresponsiveField;

  if (!showNotification) return null;

  const notifyForUnresponsiveStudentField = () => {
    var propertyName = pn<User>("notifyForUnresponsiveStudent");
    var property = properties.find((x) => x.propertyName === propertyName);

    return props.crudMode === "view" ? (
      <DataDisplay label={property?.displayName}>{formatBoolean(props.user.notifyForUnresponsiveStudent)}</DataDisplay>
    ) : (
      <Select
        modelProperty={property}
        errors={props.validationErrors[propertyName]}
        value={BOOLEAN_SELECT_LIST_ITEMS.find((x) => x.id === props.user.notifyForUnresponsiveStudent)}
        options={BOOLEAN_SELECT_LIST_ITEMS}
        getOptionLabel={(option) => option.name}
        onChange={(e, value) =>
          props.setUser(
            produce(props.user, (draft) => {
              draft.notifyForUnresponsiveStudent = value?.id;
            })
          )
        }
      />
    );
  };

  return (
    <Card header={"Notifications"} fullHeight>
      <Grid ref={breakpointsRef} container spacing="sm">
        {studentUnresponsiveField && (
          <Grid item xs={smallFieldBreakpoints}>
            {notifyForUnresponsiveStudentField()}
          </Grid>
        )}
      </Grid>
    </Card>
  );
};
